var map = {
	"./CCPH_1.json": 8040,
	"./CCPH_10.json": 4799,
	"./CCPH_2.json": 2779,
	"./CCPH_3.json": 7251,
	"./CCPH_4.json": 5368,
	"./CCPH_5.json": 9286,
	"./CCPH_6.json": 1108,
	"./CCPH_7.json": 6206,
	"./CCPH_8.json": 3052,
	"./CCPH_9.json": 6710,
	"./CCPH_residual.json": 6556,
	"./CMH_1.json": 4727,
	"./CMH_10.json": 799,
	"./CMH_11.json": 9364,
	"./CMH_12.json": 3752,
	"./CMH_13.json": 1311,
	"./CMH_14.json": 3405,
	"./CMH_15.json": 5115,
	"./CMH_2.json": 8692,
	"./CMH_3.json": 1856,
	"./CMH_4.json": 2497,
	"./CMH_5.json": 624,
	"./CMH_6.json": 930,
	"./CMH_7.json": 3207,
	"./CMH_8.json": 5558,
	"./CMH_9.json": 4017,
	"./CMH_residual.json": 321,
	"./MaoIntro_1.json": 7058,
	"./MaoIntro_10.json": 5787,
	"./MaoIntro_11.json": 4011,
	"./MaoIntro_12.json": 8657,
	"./MaoIntro_13.json": 7472,
	"./MaoIntro_14.json": 7062,
	"./MaoIntro_15.json": 952,
	"./MaoIntro_16.json": 5568,
	"./MaoIntro_2.json": 4890,
	"./MaoIntro_3.json": 9426,
	"./MaoIntro_4.json": 4676,
	"./MaoIntro_5.json": 4121,
	"./MaoIntro_6.json": 4035,
	"./MaoIntro_7.json": 1085,
	"./MaoIntro_8.json": 1277,
	"./MaoIntro_9.json": 3291,
	"./MaoIntro_residual.json": 4453,
	"./Marx_1.json": 4432,
	"./Marx_2.json": 7627,
	"./Marx_3.json": 3184,
	"./Marx_4.json": 9433,
	"./Marx_5.json": 6210,
	"./Marx_6.json": 323,
	"./Marx_7.json": 4918,
	"./Marx_8.json": 2773,
	"./Marx_residual.json": 7913,
	"./NCH_1.json": 6620,
	"./NCH_2.json": 6684,
	"./NCH_3.json": 8841,
	"./NCH_4.json": 5425,
	"./NCH_5.json": 4172,
	"./NCH_residual.json": 8453,
	"./ORH_1.json": 7686,
	"./ORH_2.json": 4110,
	"./ORH_3.json": 3917,
	"./ORH_4.json": 7267,
	"./ORH_5.json": 3048,
	"./ORH_6.json": 2854,
	"./ORH_7.json": 5785,
	"./ORH_8.json": 5295,
	"./ORH_residual.json": 9455,
	"./Political_1.json": 4602,
	"./Political_10.json": 4021,
	"./Political_11.json": 8422,
	"./Political_12.json": 6763,
	"./Political_2.json": 4286,
	"./Political_3.json": 401,
	"./Political_4.json": 7874,
	"./Political_5.json": 2527,
	"./Political_6.json": 9387,
	"./Political_7.json": 6737,
	"./Political_8.json": 1361,
	"./Political_9.json": 7348,
	"./Political_residual.json": 8428,
	"./SDH_1.json": 3907,
	"./SDH_2.json": 7647,
	"./SDH_3.json": 2272,
	"./SDH_4.json": 6243,
	"./SDH_5.json": 8703,
	"./SDH_6.json": 7356,
	"./SDH_residual.json": 3618,
	"./XiIntro_1.json": 1890,
	"./XiIntro_2.json": 2775,
	"./XiIntro_3.json": 8978,
	"./XiIntro_4.json": 4384,
	"./XiIntro_5.json": 7969,
	"./XiIntro_6.json": 2548,
	"./XiIntro_7.json": 1546,
	"./XiIntro_8.json": 3663,
	"./XiIntro_residual.json": 1906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4302;